import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Container } from '../container';
import { useScrollPosition, useViewport } from '../../utils';
import { SystemProvider } from '../../features/system/provider';
import {
  AudienceDropdown,
  HeaderNav,
  HeaderNavMobile
} from './index'

const Logo = ({...props}) => (
  <Link to="/" {...props}>
    <img
      src="/images/khub_logo.png"
      alt="K-HUB Logo"
      className="header__logo"
      width="100"
      height="45"
    />
  </Link>
)

const Header = ({ noAudienceDropdown }) => {
  const withAudienceDropdown = !noAudienceDropdown
  const { isDesktop } = useViewport()
  const [sticky, setSticky] = useState(true)

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if(!isDesktop){
        if(currPos.y < -100){
          const isShow = currPos.y > prevPos.y
          if (isShow !== sticky) setSticky(isShow)
        }
      }
    },
    [sticky]
  )

  return (
    <header
      className="fixed bg-white top-0 left-0 w-full transition-transform duration-200"
      style={{zIndex: 800, transform: `translateY(${sticky ? '0' : '-100%'})`}}
    >
      <Container className="flex justify-between items-center py-5">
        <div className="flex items-center">
          <Logo className="mr-8"/>
          {
            (withAudienceDropdown && isDesktop) &&
            <SystemProvider>
              <AudienceDropdown />
            </SystemProvider>
          }
        </div>
        {
          isDesktop ? (
            <HeaderNav />
          ) : (
            <HeaderNavMobile />
          )
        }
      </Container>
    </header>
  )
}

export { Header }
